import styles from "./index.module.less"

import { CustomBlockIcon, CustomCloseIcon, LockIcon } from "@/icons"
import { useEffect, useState } from "react"
import ReactDOM from "react-dom/client"

const EXIT_DURATION = 250

interface NotificationProps {
  itemsCount: number
  block: () => void
  unblock: () => void
  unselect: () => void
  onHiddenChange: (setHidden: (hidden: boolean) => void) => void
}

const Notification = (props: NotificationProps) => {
  const { block, unblock, unselect, itemsCount, onHiddenChange } = props
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    onHiddenChange(hidden => setVisible(!hidden))
    const frame = requestAnimationFrame(() => setVisible(true))
    return () => cancelAnimationFrame(frame)
  }, [onHiddenChange])

  return (
    <div className={`${styles.wrapper} ${visible ? styles.visible : ""}`}>
      <div className={styles.left}>
        <button className={styles.action_btn} data-action={"unselect"} onClick={unselect}>
          <CustomCloseIcon width={12} height={12} />
        </button>

        <span>{itemsCount} selected</span>
      </div>

      <div className={styles.divider} />

      <div className={styles.right}>
        <button className={styles.action_btn} data-action={"block"} onClick={block}>
          <CustomBlockIcon width={16} height={16} />

          <span>Block</span>
        </button>

        <button className={styles.action_btn} data-action={"unblock"} onClick={unblock}>
          <LockIcon width={16} height={16} />
          <span>Unblock</span>
        </button>
      </div>
    </div>
  )
}

type NotificationInputProps = Omit<NotificationProps, "onHiddenChange">

const blockNotification = (
  initialProps: NotificationInputProps
): { close: () => void; update: (props: NotificationInputProps) => void } => {
  const container = document.createElement("div")
  document.body.appendChild(container)

  const root = ReactDOM.createRoot(container)

  let setHidden: (hidden: boolean) => void = () => undefined
  const handleHiddenChange = (fn: (hidden: boolean) => void) => {
    setHidden = fn
  }

  const unmount = () => {
    root.unmount()
    document.body.removeChild(container)
  }

  const close = () => {
    setHidden(true)
    setTimeout(unmount, EXIT_DURATION)
  }

  const update = (props: NotificationInputProps) => {
    root.render(
      <Notification
        {...props}
        onHiddenChange={handleHiddenChange}
        unselect={() => {
          props.unselect()
          close()
        }}
      />
    )
  }

  update(initialProps)

  return { close, update }
}

export default blockNotification
